
import { Vue, Component } from 'vue-property-decorator'
import User from '@/types/user'
import CompanyUserCreateDetailsTab from '@/views/companyUser/tabs/create/CompanyUserCreateDetailsTab.vue'
import ls from '@/ls'

@Component({
  components: { CompanyUserCreateDetailsTab }
})

export default class CompanyUserCreate extends Vue {
  settings = {
    routeNames: { list: 'companyUsers', show: 'companyUserShow', edit: 'companyUserEdit' },
    routeParamKey: 'companyUserId',
    permissionNames: { show: 'companies.users.view', edit: 'companies.users.edit', delete: 'companies.users.delete' },
    functionNames: { setCurrent: 'setCurrentCompanyUser', clearCurrent: 'clearCurrentCompanyUser', save: 'saveCompanyUser' },
    getterNames: { current: 'currentCompanyUser', loading: 'loadingCompanyUser' }
  }

  currentTab:string = ls.get('companyUserEditActiveTab') || 'details'

  destroyed () : void {
    this.$store.dispatch(this.settings.functionNames.clearCurrent)
  }

  save () : void {
    this.$store.dispatch(this.settings.functionNames.save, this.currentItem)
  }

  setActiveTab (tab:string) : void {
    ls.set('companyUserEditActiveTab', tab)
    this.currentTab = tab
  }

  navigateTo (routeName:string, id:number|undefined) : void {
    if (id) {
      this.$router.push({ name: routeName, params: { [this.settings.routeParamKey]: id.toString() } })
    } else {
      this.$router.push({ name: routeName })
    }
  }

  previousPage () : void {
    this.$router.go(-1)
  }

  get currentItem () : User {
    return this.$store.getters[this.settings.getterNames.current]
  }

  get loading () : boolean {
    return this.$store.getters[this.settings.getterNames.loading].item
  }

  get saving () : boolean {
    return this.$store.getters[this.settings.getterNames.loading].save
  }
}
